module.exports = __webpack_public_path__ + "static/media/caprese.cc7dc2bc.jpg";